import './index.css';
import './services/testService';

import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import App from './App';
import {NavigationProvider} from './contexts/NavigationContext';
import configService from './services/config/configService';
import manifestService from './services/manifest/manifestService';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {configureStore} from './state/store';

const start = async () => {
    const store = configureStore();

    try {
        configService.initializeConfig();
        await configService.handleGeneralConfig(); // wait for the default device type before setting up the manifest
        manifestService.setupManifest();

        render(store, App);
    } catch (e) {
        console.log(e);
    }
};
const render = (store: any, App: React.ComponentType) => {
    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

    root.render(
        <Provider store={store}>
            <BrowserRouter>
                <NavigationProvider>
                    <App />
                </NavigationProvider>
            </BrowserRouter>
        </Provider>
    );
};

start();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
